import { QUESTION_TYPE_CHOICES } from 'common/constants/firms';

export const DEFAULT_QUESTION_TYPE_VALUE = QUESTION_TYPE_CHOICES[0].value;

export const getQuestionTypeValue = (questionType: number | string | undefined): number | undefined => {
  if (typeof questionType === 'number') {
    return QUESTION_TYPE_CHOICES.some(choice => choice.value === questionType) ? questionType : undefined;
  }

  return QUESTION_TYPE_CHOICES.find(choice => choice.label === questionType)?.value;
};

export const getQuestionTypeLabel = (questionType: number | string | undefined): string | undefined => {
  const questionTypeValue = getQuestionTypeValue(questionType);
  if (questionTypeValue === undefined) {
    return undefined;
  }

  return QUESTION_TYPE_CHOICES.find(choice => choice.value === questionTypeValue)?.label;
};

export const resolveQuestionTypeValue = (questionType: number | string | undefined): number =>
  getQuestionTypeValue(questionType) ?? DEFAULT_QUESTION_TYPE_VALUE;
